// Course content. Everything here is static and edited in code; the backend (GET /api/site, see
// src/context/SiteContext.jsx) only supplies the current batch, the site notice and the payment numbers.
import { toBn } from '../lib/utils';
import { walletNames } from '../lib/payment';

// One entry per live class, in order. The class count shown across the page is the number of entries.
export const curriculum = [
  {
    title: 'Excel পরিচিতি ও ডেটা এন্ট্রি',
    topics: ['Excel ইন্টারফেস, Cell, Row ও Column', 'Data Entry, AutoFill ও Flash Fill', 'Number, Date ও Currency Format', 'Cell Formatting ও প্রিন্টের জন্য সাজানো'],
  },
  {
    title: 'ফর্মুলা ও বেসিক ফাংশন',
    topics: ['ফর্মুলা লেখার নিয়ম ও Operator', 'SUM, AVERAGE, MIN, MAX, COUNT', 'Relative ও Absolute Reference ($)', 'শতকরা হিসাব ও ROUND'],
  },
  {
    title: 'লজিক্যাল ফাংশন ও শর্তসাপেক্ষ হিসাব',
    topics: ['IF ও Nested IF', 'AND, OR দিয়ে একাধিক শর্ত', 'COUNTIF, COUNTIFS', 'SUMIF, SUMIFS'],
  },
  {
    title: 'লুকআপ ফাংশন — ডেটা খুঁজে বের করা',
    topics: ['VLOOKUP ও HLOOKUP', 'XLOOKUP', 'INDEX ও MATCH', 'IFERROR দিয়ে ভুল সামলানো'],
  },
  {
    title: 'Text ও Date ফাংশন, ডেটা ক্লিনিং',
    topics: ['LEFT, RIGHT, MID, TRIM, TEXTJOIN', 'TODAY, DATEDIF, NETWORKDAYS', 'Remove Duplicates ও Text to Columns', 'অগোছালো ডেটা গুছিয়ে নেওয়া'],
  },
  {
    title: 'ডেটা ম্যানেজমেন্ট ও চার্ট',
    topics: ['Sort, Filter ও Excel Table', 'Conditional Formatting', 'Data Validation ও Drop-down', 'Chart তৈরি ও সাজানো'],
  },
  {
    title: 'Pivot Table ও অফিস প্রজেক্ট',
    topics: ['Pivot Table ও Pivot Chart দিয়ে রিপোর্ট', 'Salary Sheet তৈরি', 'Result Sheet ও Attendance Sheet', 'Sheet Protect, Print Setup + প্রশ্নোত্তর'],
  },
];

export const bonuses = [
  { icon: '🎥', title: 'প্রতিটি ক্লাসের রেকর্ডিং', desc: 'ক্লাস মিস হলেও চিন্তা নেই — পরে দেখে নিতে পারবেন।' },
  { icon: '📁', title: 'প্র্যাকটিস ফাইল', desc: 'প্রতিটি ক্লাসের Excel প্র্যাকটিস শিট।' },
  { icon: '💬', title: 'প্রাইভেট সাপোর্ট গ্রুপ', desc: 'ক্লাসের বাইরেও প্রশ্ন করার সুযোগ।' },
  { icon: '🏅', title: 'কোর্স সম্পন্নের সার্টিফিকেট', desc: 'সিভিতে যোগ করার মতো ই-সার্টিফিকেট।' },
];

export const course = {
  brand: 'MS Office School',
  instructor: {
    name: 'Wazed Ali',
    nameBn: 'ওয়াজেদ আলী',
    title: 'MS Excel ট্রেইনার, MS Office School',
    photo: 'https://t2.tenbytecloud.com/abid/web-assets/ms-office-school/wazed.jpeg', // URL or /public path; null shows initials
    bio: 'শিক্ষার্থী ও অফিস কর্মীদের হাতে-কলমে MS Excel শেখানোই তাঁর কাজ। জটিল ফর্মুলাকে সহজ বাংলায়, বাস্তব অফিসের উদাহরণ দিয়ে বুঝিয়ে দেন — যাতে ক্লাস শেষ করেই কাজে লাগাতে পারেন।',
  },

  totalClasses: curriculum.length,
  windowDays: 15,
  classGapDays: 2, // a class every other day: day 1, 3, 5, ... 13

  contact: {
    // WhatsApp in international format without "+", e.g. '8801XXXXXXXXX'. Empty string hides it.
    whatsapp: '',
    phone: '',
    email: '',
    facebook: 'https://www.facebook.com/msofficeschoolbd',
  },

  // Batch fields come from the backend. These are shown until it responds, and kept if it can't be reached.
  // Times are Bangladesh time (+06:00). They may be null when no batch is open.
  batchId: null,
  batchName: 'অক্টোবর ব্যাচ',
  batchStart: '2026-10-18T21:00:00+06:00',
  enrollDeadline: '2026-10-16T23:59:00+06:00',
  classTime: 'রাত ৯:০০ – ১০:৩০',
  platform: 'Zoom',
  price: 299,
  regularPrice: 1500, // null hides the strike-through price and discount badge
  enrollmentOpen: true,
  showSeats: true,
  seatsTotal: 50,
  seatsLeft: 17,
};

// Built from the live batch and payment numbers so the answers always match them.
export function buildFaqs(course, payment) {
  return [
    {
      q: 'ক্লাসগুলো কোথায় ও কীভাবে হবে?',
      a: `সব ক্লাস লাইভ অনলাইনে${course.platform ? ` ${course.platform}-এ` : ''} হবে। ভর্তির পর ক্লাস লিংক ও সময়সূচি আপনাকে পাঠিয়ে দেওয়া হবে।`,
    },
    {
      q: `${toBn(course.windowDays)} দিনে ${toBn(course.totalClasses)}টি ক্লাস কীভাবে হবে?`,
      a: `একদিন ক্লাস, একদিন বিরতি। বিরতির দিনে আগের ক্লাসের বিষয় প্র্যাকটিস করবেন। এভাবে ${toBn(course.windowDays)} দিনের মধ্যেই পুরো কোর্স শেষ হয়ে যায়।`,
    },
    {
      q: 'আমি একদম নতুন, Excel কিছুই জানি না — পারব?',
      a: 'অবশ্যই। কোর্সটি একদম শুরু থেকে সাজানো, তাই আগে থেকে কিছু জানা লাগবে না। শুধু শেখার আগ্রহ থাকলেই চলবে।',
    },
    {
      q: 'কী কী লাগবে?',
      a: 'MS Excel ইনস্টল করা একটি ল্যাপটপ বা কম্পিউটার এবং ইন্টারনেট সংযোগ। Excel-এর যেকোনো ভার্সনেই শিখতে পারবেন; XLOOKUP-এর মতো নতুন ফাংশনের জন্য Excel 2021 বা Microsoft 365 লাগবে। মোবাইল দিয়ে ক্লাসে যোগ দেওয়া গেলেও প্র্যাকটিসের জন্য কম্পিউটার থাকা ভালো।',
    },
    {
      q: 'কোনো ক্লাস মিস করলে কী হবে?',
      a: 'প্রতিটি ক্লাসের রেকর্ডিং দেওয়া হবে, তাই মিস হলেও পরে দেখে নিতে পারবেন।',
    },
    {
      q: 'পেমেন্ট কীভাবে করব?',
      a: payment.length
        ? `ভর্তি ফর্মে ${walletNames(payment)} থেকে একটি বেছে নিন এবং দেখানো পার্সোনাল নম্বরে কোর্স ফি Send Money করুন। তারপর যে নম্বর থেকে টাকা পাঠিয়েছেন সেটি ও ট্রানজেকশন আইডি (TrxID) লিখে ফর্ম সাবমিট করুন। পেমেন্ট যাচাই করে আমরা আপনার সিট নিশ্চিত করব।`
        : 'ফর্মটি পূরণ করে সাবমিট করুন। আমাদের টিম আপনার সাথে যোগাযোগ করে পেমেন্টের নিয়ম জানিয়ে দেবে।',
    },
  ];
}
